export const FloracionTable = {
    nombre:"text",
    zona:"text",
    humedad:"text",
    color:"text",
    isEdit: "isEdit"
}
